import m, {Vnode} from "mithril";
import TFeedbackDefinition, {TFeedbackComponent} from "../../model/feedback/TFeedbackDefinition";
import FeedbackModel from "../../model/feedback/FeedbackModel";
import FeedbackFactory from "../../model/feedback/FeedbackFactory";
import {Questionary} from "../../model/questionary";

export default class FeedbackView {

    private readonly model: FeedbackModel;
    private readonly factory: FeedbackFactory;

    private finished = false;
    private communicationError = false;
    private fetching = false;

    private readonly self: FeedbackView;

    constructor(
        private readonly definition: TFeedbackDefinition,
        private readonly questionary: Questionary,
    ) {
        this.model = new FeedbackModel(definition);
        this.factory = new FeedbackFactory(definition, this.model, this.questionary);
        this.self = this;
    }

    public isFinished(): boolean {
        return this.finished;
    }

    private async save() {
        this.self.communicationError = false;
        this.self.fetching = true;
        try {
            await m.request(this.definition.api.url, {
                method: this.definition.api.method ?? 'POST',
                data: this.model.getData(),
            });
            this.self.finished = true;
        } catch (err) {
            this.self.communicationError = true;
        } finally {
            this.self.fetching = false;
            m.redraw();
        }
    }

    private viewComponent(definition: TFeedbackComponent): Vnode|null {
        return this.model.isVisible(definition) ? this.factory.createComponentView(definition) : null;
    }

    private viewHeader(): Vnode|null {
        const headerDefinition= this.factory.getHeaderDefinitions()
        if (!headerDefinition.length) {
            return null;
        }

        return m(".header", {}, headerDefinition.map(def => this.viewComponent(def)));
    }

    private viewForm(): Vnode {
        const formDefinition = this.factory.getFormDefinitions();
        return  m("div.content",
            m("form", {},
                formDefinition.map(def => this.viewComponent(def))
            )
        );
    }

    private viewControls(): Vnode {

        return m(".controls",
            m(".control-group",
                m("button.btn.large.raised.primary.has-primary-background", {
                    id: 'nextButton',
                    tabindex: 1,
                    onclick: () => this.communicationError ? this.self.finished = true : this.save(),
                }, [
                    m("span", {}, this.questionary.messages.get("nextButton")),
                    m("i.icon.icon-chevron-right")
                ])
            )
        )
    }

    private fetchingView(): Vnode {
        return m('.form.loading', {}, [
            m('.loader', {}, [
                m('.loader-spinner'+(this.communicationError ? '.stop' : '')),
                this.communicationError ? m('.loader-message', {}, m.trust(this.questionary.messages.get('savingFeedbackFailed'))) : null,
                this.communicationError ? m('.text-center', {}, [
                    m('button.btn.outline.link', {
                        onclick: () => this.self.finished = true,
                    }, this.questionary.messages.get('skip')),
                    m.trust('&nbsp;'),
                    m('button.btn.raised.primary', {
                        onclick: () => this.save()
                    }, this.questionary.messages.get('tryAgain'))
                ]) : null,
            ]),
        ])
    }

    view(): Vnode {
        if (this.fetching || this.communicationError) {
            return this.fetchingView();
        }

        return m(".isCustomForm.form-feedback",
            m(".customForm",
                [
                    this.viewHeader(),
                    m(".form.appear-right.customForm-General.Feedback",
                        [
                            this.viewForm(),
                            this.viewControls(),
                        ]
                    )
                ]
            )
        )
    }
}
